import { MenuItem } from '@mui/material'
import { Field } from 'formik'
import React from 'react'
import { CustomTextField } from 'src/form'

const MARITAL_STATUS_SELECTIONS = [
  { value: 'SINGLE', label: 'Single' },
  { value: 'MARRIED', label: 'Married' },
  { value: 'DOMESTIC_PARTNERSHIP', label: 'Domestic Partnership' },
  { value: 'DIVORCED', label: 'Divorced' },
  { value: 'WIDOWED', label: 'Widowed' },
  { value: 'SEPARATED', label: 'Separated' },
]

export const MaritalStatusField = () => (
  <Field component={CustomTextField} fullWidth label="Marital Status" name="patient.maritalStatus" type="select">
    {MARITAL_STATUS_SELECTIONS.map(({ value, label }) => (
      <MenuItem key={value} value={value}>
        {label}
      </MenuItem>
    ))}
  </Field>
)
